import React, { useContext } from "react";
import { AppContext } from "../App";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import productImg from "../assets/prod-soldrax.png";

export default function Viewoldrax() {
  const { navTo } = useContext(AppContext);

  return (
    <main className="viewoldrax-minimal">

      {/* Hero Section */}
      <section className="vm-hero">
        <header className="vm-hero-header">
          <h2 className="text-primary font-bold">
            A professional-grade utility designed for speed, security, and simplicity.
          </h2>
          
          <div className="vm-button-group mt-5">
            <a href="#ios" className="vm-btn-store">
              <FaApple /> <span>App Store</span>
            </a>
            <a href="#android" className="vm-btn-store">
              <FaGooglePlay /> <span>Play Store</span>
            </a>
          </div>
        </header>

        {/* Product Snippet */}
        <div className="vm-product-container">
          <div className="vm-image-stage">
            <img 
              src={productImg} 
              alt="Application Preview" 
              className="vm-main-image" 
            />
          </div>
        </div>
      </section>
    </main>
  );
}